module.exports = __webpack_public_path__ + "static/2.4MoveObjectAway-dbe1f06fc1ed9f7c43a7a4bf2fdc1083.gif";